module.exports = __webpack_public_path__ + "media/images/pages/ic-camera-9e89acb8889691ec1551a2df0ba31182.png";